import React, {useState} from 'react';
import {Button, Divider, TextField} from '@material-ui/core';

import styles from './LoginComponent.module.css';

interface Props {
    setLogged: Function,
}

const LoginComponent = (props: Props) => {
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const isLogged = username === 'LabAdmin' && password === '!4LabCodeAdmin#';

        props.setLogged(isLogged);
    }

    return (
        <div className={styles.LoginComponent}>
            <h1>Autenticação necessária</h1>
            <Divider flexItem />
            <form onSubmit={handleSubmit}>
                <TextField
                    required
                    margin="normal"
                    id="username"
                    label="Usuário"
                    variant="outlined"
                    type="text"
                    onChange={e => setUserName(e.target.value)}
                />
                <TextField
                    required
                    margin="normal"
                    id="password"
                    label="Senha"
                    variant="outlined"
                    type="password"
                    onChange={e => setPassword(e.target.value)}
                />
                <Button type="submit" variant="outlined" color="primary">Entrar</Button>
            </form>
        </div>
    );
}

export default LoginComponent;
